// extracted by mini-css-extract-plugin
export default {"layout":"BonusWithGamesPopup__layout--aF6","game":"BonusWithGamesPopup__game--hRK"};